module.exports = __webpack_public_path__ + "static/img/16.5320286.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/zh/16.png
// module id = 4K+E
// module chunks = 0